import { createRoot, type Root } from "react-dom/client";
import Ministries from "../pages/Ministries/Ministries";
import "../index.css";
import "../pages/Ministries/Ministries.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<Ministries />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADMinistries = { mount, unmount };

function boot() {
  const element = document.getElementById("ministries-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
